import { listCoverageSplitSummaries } from "./list-coverage-split-summaries";

export const listLegacyCoverageSplits = {
  name: "listLegacyCoverageSplits" as const,
  input: listCoverageSplitSummaries.input,
  output: listCoverageSplitSummaries.output,
};
